import Debug from 'debug';
import _ from 'lodash';
import moment from 'moment-timezone';
const debug = Debug(`knack.core.helpers.reports.processSQLDateTimeGroupWeek`);
export const processSQLDateTimeGroupWeek = (group, old_filters, app_now, column, filter, report, current_moment_time) => {
    debug(`report-helper.processSQLDateTimeGroupWeek`);
    const now = _.cloneDeep(current_moment_time);
    let limit;
    let offset;
    if (group.limit === `from_to` || group.limit === `from`) {
        const to = (group.limit == `from_to`) ? moment(group.date_to).subtract(1, `days`).startOf(`day`) : now;
        const from = moment(group.date_from).subtract(1, `days`).startOf(`day`);
        limit = Math.ceil(to.diff(from, `weeks`, true)) + 1;
        offset = now.diff(to, `weeks`) + 1;
        if (offset < 0) {
            offset = Math.floor(now.diff(to, `weeks`, true));
        }
        debug(`WEEK:::: from: ${from.format(`MM/DD/YY`)} to: ${to.format(`MM/DD/YY`)}; diff: ${to.diff(from, `weeks`, true)}; offset: ${offset}; limit: ${limit}`);
    }
    else {
        limit = group.number;
        offset = 0;
    }
    if (limit === 0) {
        limit = 1;
    }
    debug(`difference in weeks, limit is: ${limit}; offset is: ${offset} day_of_week: ${now.format(`d`)}`);
    return _(limit).times(function (i) {
        if (group.sort === `asc`) {
            i = (limit - 1) - i;
        }
        debug(`iteration value for week grouping: ${i}`);
        const current_date = _.cloneDeep(current_moment_time);
        debug(`current date is: ${current_date.format()}`);
        const day_of_week = Number(current_date.format(`d`));
        if (current_date.format(`d`) !== `0`) {
            current_date.day(0);
        }
        const offsetFromCurrentWeek = i + offset;
        current_date.subtract(offsetFromCurrentWeek, `weeks`);
        const header = current_date.format(`MMM D`);
        debug(`checking week: ${offsetFromCurrentWeek}; day_of_week: ${day_of_week} header: ${header}`);
        const from = (new moment(app_now).utc()).endOf(`day`);
        const to = (new moment(app_now).utc()).endOf(`day`);
        if (offsetFromCurrentWeek > 0) {
            from.subtract((offsetFromCurrentWeek + 1) * 7 - (6 - day_of_week), `days`);
        }
        else if (offsetFromCurrentWeek < 0) {
            from.add(0 - offsetFromCurrentWeek * 7 - (day_of_week + 1), `days`);
        }
        else {
            from.subtract(day_of_week + 1, `days`);
        }
        if (offsetFromCurrentWeek > 0) {
            to.subtract(offsetFromCurrentWeek * 7 - (6 - day_of_week), `days`);
        }
        else if (i + offset < 0) {
            to.add(0 - offsetFromCurrentWeek * 7 + (6 - day_of_week), `days`);
        }
        else {
            if (6 - day_of_week !== 0) {
                to.add(6 - day_of_week, `days`);
            }
        }
        const value = [
            from.toDate(),
            to.toDate()
        ];
        const new_filter = _.cloneDeep(filter);
        new_filter.push({
            field: group.field,
            operator: `is date range`,
            value,
            header
        });
        debug(`week ${offsetFromCurrentWeek}; header: ${header} is: ${JSON.stringify(value)}`);
        report.filters.unshift(new_filter);
        if (column === 0) {
            report.filter_groups[report.filter_groups.length - 1].unshift({
                header
            });
        }
    });
};
